import WithSidebar from "../../../layouts/WithSidebar"
import MemberForm from "../../../components/Member-form"
import { useLocation, useSearchParams } from "react-router-dom"

const SingleMember = () => {
    const {state} = useLocation()
    const [searchParams] = useSearchParams()

    const type = searchParams.get('type')
    console.log(type, 'type ee user')
    return (
        <WithSidebar pageTitle="Member Management" breadcrumb={"Dashboard > Members > Detail"}>
            <MemberForm type={type} state={state}/>
        </WithSidebar>
    )

}

export default SingleMember